import { config } from '@/constants/page.js'
import store from '@/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config[store.state.apiKey].serverUrl}`,
    timeout: 30000
  })

const sprcApi = {
  getToken: () => {
    return instance().post(
      'api/sprc/v1/auth/token',
      {},
      {
        headers: {
          AUTHORIZATION:
            'Bearer jhBQgAqphEZsAx+JTzjToTK1ULSBpaIp1xJZ30l+P9vGU2ngFBtMbEIjAtHmH2K/QixMmAR0HXljM+TEiJ8UmQ=='
        }
      }
    )
  },
  regis: (body, access_token) => {
    return instance().post('/api/sprc/v1/register', body, {
      headers: {
        AUTHORIZATION: `Bearer ${access_token}`
      }
    })
  },
  login: (body, access_token) => {
    return instance().post('/api/sprc/v1/login', body, {
      headers: {
        AUTHORIZATION: `Bearer ${access_token}`
      }
    })
  }
}
export default sprcApi
